import React, { useState, useEffect } from 'react';
import AutoCompleteDropdown from '../../../Form/AutoCompleteDropdown';

export const AutoCompleteEditor = ({ data, value, label, api, items, field, onChange }) => {
    const [state, setState] = useState(data[value] !== undefined ? items.filter(e => e[value] === data[value])[0] : null);


    const changeValor = (e) => {
        if (state) {
            if (state[value] !== undefined) {
                data[value] = state[value];
                data[label] = state[label];
            }
        } else {
            data[value] = null;
            data[label] = null;
        }
        setState(e);
        setTimeout(() => {
            if (onChange) {
                onChange({ state: e, data, value, label, api, items, oldValue: state });
            }
        }, 100);
    }


    useEffect(() => {
        if (state) {
            if (state[value] !== undefined) {
                data[value] = state[value];
                data[label] = state[label];
            }
        }
        // if (onChange && state) {
        //     onChange({ state: state, data, value, label, api, items, oldValue: state });
        // }
        // onChange({state: state, data, value, label, api, items, oldValue: state});
    }, [state])

    return <div>
        <AutoCompleteDropdown
            name={label}
            value={state}
            items={items}
            field={label}
            setValue={changeValor}
            stopEditing={() => setTimeout(() => {
                api.stopEditing();
            }, 100)}
        />
    </div>
}

export default AutoCompleteEditor